import React from 'react'

import { Field } from 'formik'

import { Form, Col } from '_zari/core'

import { SelectFlujoEfectivo } from 'sharedComponents/select'

import { KeyEventUtil } from 'utils'

const FlujosEfectivoFormGroup = ({ iError, iTouched, fIsSubmitting }) => {
  const onKeyDown = React.useCallback(e => {
    KeyEventUtil.leaveOnEnterOrTab('button-entregaARenidr-procesar', e)
  }, [])

  return (
    <Form.Group>
      <Form.Label text='FLUJO EFECTIVO' htmlFor='select-entregaARenidr-flujoEfectivo' md={4} alignRightAt='md' />
      <Col md={8}>
        <Field name='flujoEfectivo'>
          {({ field }) => (
            <SelectFlujoEfectivo
              {...field}
              disabled={fIsSubmitting}
              isInvalid={iTouched && iError}
              id='select-entregaARenidr-flujoEfectivo'
              onKeyDown={onKeyDown}
            />
          )}
        </Field>
        {iTouched && iError ? <Form.Feedback type='invalid'>{iError}</Form.Feedback> : null}
      </Col>
    </Form.Group>
  )
}

export default React.memo(FlujosEfectivoFormGroup)
